import { application } from "./application"

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import NotificationOffcanvasController from "./notification_offcanvas_controller"
application.register("notification-offcanvas", NotificationOffcanvasController)

import PasswordConfirmationController from "./password_confirmation_controller"
application.register("password-confirmation", PasswordConfirmationController)

import PhoneNumberController from "./phone_number_controller.js"
application.register("phone-number", PhoneNumberController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import FieldUnlockController from "./field_unlock_controller"
application.register("field-unlock", FieldUnlockController)

import WizardStepController from "./wizard_step_controller"
application.register("wizard-step", WizardStepController)

import IntegrationPollingController from "./integration_polling_controller"
application.register("integration-polling", IntegrationPollingController)
